import HeroSection from './components/HeroSection';
import PhilosophySection from './components/PhilosophySection';
import CategoryShowcase from './components/CategoryShowcase';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '喵绅士',
    alternateName: 'Mr. Meow',
    url: 'https://yufangwlkk.cn',
    description: '喵绅士是一个专为爱猫人士打造的高雅精品平台，汇聚猫咪文化、绅士美学与精致生活方式，探索喵绅士独特的养猫哲学、精选猫咪好物与优雅铲屎官生活指南。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://yufangwlkk.cn/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '喵绅士',
    alternateName: 'Mr. Meow',
    url: 'https://yufangwlkk.cn',
    description: '高雅猫咪文化与精品生活方式平台',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '愚园路168号',
      addressLocality: '上海',
      addressRegion: '静安区',
      addressCountry: 'CN',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-21-5208-6666',
      contactType: 'customer service',
    },
    sameAs: [
      'https://weibo.com/mrmeow',
      'https://www.xiaohongshu.com/mrmeow',
    ],
  };

  const webpageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '喵绅士 - 高雅猫咪文化与精品生活方式',
    description: '喵绅士，专为爱猫人士打造的高雅精品平台。汇聚猫咪文化、绅士美学与精致生活方式，探索喵绅士独特的养猫哲学、精选猫咪好物与优雅铲屎官生活指南。',
    url: 'https://yufangwlkk.cn',
    isPartOf: {
      '@type': 'WebSite',
      name: '喵绅士',
      url: 'https://yufangwlkk.cn',
    },
    about: {
      '@type': 'Organization',
      name: '喵绅士',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageJsonLd)}</script>
      <main>
        <HeroSection />
        <PhilosophySection />
        <CategoryShowcase />
        <FeaturedArticles />
        <FAQSection />
        <NewsletterSection />
      </main>
    </>
  );
}